<template>
  <!-- 红包碎片 -->
  <div class="mask-content">
    <van-overlay :show="show" class="overlay" duration="0.05" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="mask-cont">
          <!-- 头部“每日登陆奖励”文字 -->
          <div class="mask-cont-header">
            <img :src="imgs[0]" />
          </div>
          <!-- 金币动态图片 -->
          <div class="mask-fragmentsGif">
            <img :src="imgs[1]" />
          </div>
          <!-- 底部font -->
          <div class="mask-font">
            <p class="mask-font-fragNum">+20碎片</p>
            <span class="mask-font-p">集满100碎片可兑换奖学金红包</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { register } from '@/plugin/popup'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      show: false,
      imgs: [
        'https://img.yzcdn.cn/upload_files/2020/09/23/Fg-ukZGGIfct3U4u1B8ykcDZKiKD.png',
        'https://img.yzcdn.cn/upload_files/2020/09/24/Fnfaupti-2DcnGgzzpfPSNkTnklY.gif'
      ],
      timeout: false
    }
  },
  computed: {
    ...mapGetters(['openid'])
  },
  mounted() {
    register({
      name: 'PopupFragments',
      open: ({ afterClose }) => {
        this.afterClose = afterClose
        this.show = true
        // 15秒后超时, 自动关闭
        const __timerTimeout = setTimeout(() => {
          this.timeout = true
          this.close()
        }, 15000)
        // 调用领取接口加载完图片后回调,防止用户看不到弹窗内容,弹窗就消失了
        Promise.all([this.getPieces(), this.getscholarship(), this.loadImgs()]).then(() => {
          // 领取成功, 2s后自动关闭
          setTimeout(() => {
            if (this.show && !this.timeout) {
              clearTimeout(__timerTimeout)
              this.close()
            }
          }, 2000)
        })
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    loadImgs() {
      return new Promise((resolve) => {
        let len = 0
        const imgsLen = this.imgs.length
        this.imgs.forEach((imgUrl) => {
          const img = new Image()
          img.addEventListener('load', () => {
            len++
            if (len >= imgsLen) {
              resolve()
            }
          })
          img.src = imgUrl
        })
      })
    },
    close() {
      this.show = false
      if (this.afterClose) {
        this.afterClose()
      }
    },
    getscholarship() {
      return this.$http.get(`/cms/redenvelope/getscholarship?openid=${this.openid}`).then((res) => {
        if (res.data) {
          this.$store.commit('user/setRedMoney', res.data.money || 0)
        }
      })
    }, // 用户红包碎片
    getPieces() {
      return this.$http.get(`/cms/redenvelope/getred?openid=${this.openid}`).then((res) => {
        if (res.data) {
          this.$store.commit('user/setRedNum', res.data.fragmentNum)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mask-content {
  position: relative;
  animation: change 0.3s ease;
}
.overlay {
  z-index: 999;
}
@keyframes change {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.75);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.25);
  }
  100% {
    transform: scale(0);
  }
}
.mask-cont {
  width: 100%;
  height: 50vh;
  position: absolute;
  top: 50%;
  margin-top: -25vh;
  z-index: 999999 !important;
  .mask-cont-header {
    width: 6.83rem;
    height: 1.53rem;
    margin: auto;
    margin-bottom: 0.47rem;
    img {
      width: 6.83rem;
      height: 1.53rem;
    }
  }
  .mask-fragmentsGif {
    width: 7.73rem;
    height: 4.61rem;
    margin: auto;
    margin-bottom: 0.48rem;
    img {
      width: 7.73rem;
      height: 4.61rem;
    }
  }
  .mask-font {
    text-align: center;
    line-height: 1;
    font-size: 0;
    .mask-font-p {
      font-size: 0.4rem;
      color: #ffffff;
    }
    .mask-font-fragNum {
      font-size: 0.69rem;
      color: #ffde70;
      margin-bottom: 0.32rem;
    }
  }
}
</style>
}
</style>
